<template>

</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'
import Footer from '../../../../../../../components/FormComponents/Footer.vue';
import Checkbox from 'primevue/checkbox';
import DatePicker from '../../../../../../../components/FormComponents/DatePicker.vue';
import TextField from '../../../../../../../components/FormComponents/TextInput.vue';
export default defineComponent({
    components: {
        Footer,
        Checkbox,
        DatePicker,
        TextField
    },
    props: {
        execution_pop: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {

        return {

        }
    },
})
</script>
